"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.plugins = exports.allowedTypes = exports.components = void 0;
const react_1 = __importDefault(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const Radio_1 = require("decentraland-ui/dist/components/Radio/Radio");
const Table_1 = require("decentraland-ui/dist/components/Table/Table");
const omit_1 = __importDefault(require("lodash/omit"));
const remark_emoji_1 = __importDefault(require("remark-emoji"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const Blockquote_1 = __importDefault(require("./Blockquote"));
const Bold_1 = __importDefault(require("./Bold"));
const Code_1 = __importDefault(require("./Code"));
const Italic_1 = __importDefault(require("./Italic"));
const Link_1 = __importDefault(require("./Link"));
const List_1 = __importStar(require("./List"));
const MainTitle_1 = __importDefault(require("./MainTitle"));
const Paragraph_1 = __importDefault(require("./Paragraph"));
const SubTitle_1 = __importDefault(require("./SubTitle"));
const Title_1 = __importDefault(require("./Title"));
exports.components = {
    h1: react_1.default.memo((props) => react_1.default.createElement(MainTitle_1.default, Object.assign({}, (0, omit_1.default)(props, ['node', 'level'])))),
    h2: react_1.default.memo((props) => react_1.default.createElement(Title_1.default, Object.assign({}, props))),
    h3: react_1.default.memo((props) => react_1.default.createElement(SubTitle_1.default, Object.assign({}, props))),
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    del: 'del',
    p: react_1.default.memo((props) => react_1.default.createElement(Paragraph_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    strong: react_1.default.memo((props) => react_1.default.createElement(Bold_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    em: react_1.default.memo((props) => react_1.default.createElement(Italic_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    a: react_1.default.memo((props) => react_1.default.createElement(Link_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    code: react_1.default.memo((props) => {
        const result = (props.className || '').match(/^language-(\w+)$/);
        const language = result ? result[1] : undefined;
        return react_1.default.createElement(Code_1.default, Object.assign({ language: language }, (0, omit_1.default)(props, ['node'])));
    }),
    pre: react_1.default.memo((props) => react_1.default.createElement("pre", Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    blockquote: react_1.default.memo((props) => react_1.default.createElement(Blockquote_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    ol: react_1.default.memo((props) => react_1.default.createElement(List_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    ul: react_1.default.memo((props) => react_1.default.createElement(List_1.default, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    li: react_1.default.memo((props) => react_1.default.createElement(List_1.ListItem, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    input: react_1.default.memo((_a) => {
        var { disabled } = _a, props = __rest(_a, ["disabled"]);
        return (react_1.default.createElement(Radio_1.Radio, Object.assign({ readOnly: disabled }, (0, omit_1.default)(props, ['node']))));
    }),
    table: react_1.default.memo((props) => react_1.default.createElement(Table_1.Table, { basic: "very" }, props.children)),
    tbody: react_1.default.memo((props) => react_1.default.createElement(Table_1.Table.Body, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    thead: react_1.default.memo((props) => react_1.default.createElement(Table_1.Table.Header, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    tr: react_1.default.memo((props) => react_1.default.createElement(Table_1.Table.Row, Object.assign({}, (0, omit_1.default)(props, ['node'])))),
    th: react_1.default.memo((props) => (react_1.default.createElement(Table_1.Table.HeaderCell, Object.assign({}, (0, omit_1.default)(props, ['node', 'isHeader']))))),
    td: react_1.default.memo((props) => (react_1.default.createElement(Table_1.Table.Cell, Object.assign({}, (0, omit_1.default)(props, ['node', 'isHeader']))))),
};
exports.allowedTypes = ['root', 'text'].concat(Object.keys(exports.components));
exports.plugins = [remark_gfm_1.default, remark_emoji_1.default];
exports.default = react_1.default.memo(function Markdown(props) {
    return (react_1.default.createElement(react_markdown_1.default, Object.assign({}, props, { components: exports.components, remarkPlugins: exports.plugins })));
});
